module.exports = __webpack_public_path__ + "static/media/PR_55_05.89603004.jpg";